import { strReplace } from '../../../../../services/strings';
import { pageLang } from '../../../services/app-storage';
import { CurrencyCode, ICurrency } from './currency-storage';

export function convertCurrency(price: number, from: ICurrency, to: ICurrency): number {
    return price * to.exchange / from.exchange;
}

export function formatCurrency(value: number, code: CurrencyCode, noDigits = false): string {
    if (noDigits) {
        return getCurrencySymbol(code) + ' ' + value.toFixed(0);
    }

    return typeof value.toLocaleString === 'undefined'
        ? `${code} ${value.toFixed(2)}`
        : value.toLocaleString(pageLang, {
            style: 'currency',
            currency: code
        });
}

export function getCurrencySymbol(code: CurrencyCode, lang = pageLang): string | null {
    if (typeof ''.toLocaleString === 'undefined') {
        return null;
    }

    return strReplace(
        strReplace(
            strReplace(
                (0).toLocaleString(lang, { style: 'currency', currency: code })
                , '0', ''),
            '.', ''),
        ',', ''
    ).trim();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/currencies/index.ts